import { createSlice } from "@reduxjs/toolkit";

const values = [
    {
        "formType": 'ІГХ',
        "idetifier":[
            "description",
            "conclusion",
            "doc",
            "archive",
            "sign"
        ],
        "title": 'ІГХ висновок',
        "dataType": 'doctor',
        "fields": [
            {
                "legend": 'Мікроопис',
                "id":1,
                "type": 'textarea',
                "required": true,
                "name": 'description',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Патоморфологічний висновок',
                "id":2,
                "type": 'textarea',
                "required": true,
                "name": 'conclusion',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Лікар',
                "id":3,
                "type": 'text',
                "required": true,
                "name": 'doc',
                "options": true,
                "props": []
            },
            {
                "legend": 'Зберігання в архіві',
                "id":4,
                "type": 'radio',
                "required": true,
                "name": 'archive',
                "options": false,
                "props": [
                    {
                    "label": '1 рік',
                    "id":661,
                    "type": 'radio'
                    },
                    {
                    "label": '3 Роки',
                    "id":662,
                    "type": 'radio'
                    },
                    {
                    "label": '10 Років',
                    "id":662,
                    "type": 'radio'
                    },
                ] 
            },
        ],
        "button": "Сформувати заключення",
        "class": 'form__box__register'
    },{
        "formType": 'CISH',
        "idetifier":[
            "description",
            "conclusion",
            "doc",
            "archive",
            "sign"
        ],
        "title": 'CISH висновок',
        "dataType": 'doctor',
        "fields": [
            {
                "legend": 'Макроскоповий опис',
                "id":1,
                "type": 'textarea',
                "required": true,
                "name": 'description',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Патоморфологічний висновок',
                "id":2,
                "type": 'text',
                "required": true,
                "name": 'conclusionTable',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Лікар',
                "id":3,
                "type": 'text',
                "required": true,
                "name": 'doc',
                "options": true,
                "props": []
            },
            {
                "legend": 'Зберігання в архіві',
                "id":4,
                "type": 'radio',
                "required": true,
                "name": 'archive',
                "options": false,
                "props": [
                    {
                    "label": '1 рік',
                    "id":661,
                    "type": 'radio'
                    },
                    {
                    "label": '3 Роки',
                    "id":662,
                    "type": 'radio'
                    },
                    {
                    "label": '10 Років',
                    "id":662,
                    "type": 'radio'
                    },
                ] 
            },
        ],
        "button": "Сформувати заключення",
        "class": 'form__box__register'
    },{
        "formType": 'Експрес',
        "idetifier":[
            "color",
            "description",
            "conclusion",
            "doc",
            "archive",
            "sign"
        ],
        "title": 'Експрес висновок',
        "dataType": 'doctor',
        "fields": [
            {
                "legend": 'Методи забарвлення',
                "id":1,
                "type": 'textarea',
                "required": true,
                "name": 'color',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Мікроопис',
                "id":2,
                "type": 'textarea',
                "required": true,
                "name": 'description',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Патоморфологічний висновок',
                "id":3,
                "type": 'textarea',
                "required": true,
                "name": 'conclusion',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Лікар',
                "id":4,
                "type": 'text',
                "required": true,
                "name": 'doc',
                "options": true,
                "props": []
            },
            {
                "legend": 'Зберігання в архіві',
                "id":5,
                "type": 'radio',
                "required": true,
                "name": 'archive',
                "options": false,
                "props": [
                    {
                    "label": '1 рік',
                    "id":661,
                    "type": 'radio'
                    },
                    {
                    "label": '3 Роки',
                    "id":662,
                    "type": 'radio'
                    },
                    {
                    "label": '10 Років',
                    "id":662,
                    "type": 'radio'
                    },
                ] 
            },
        ],
        "button": "Сформувати заключення",
        "class": 'form__box__register'
    },{
        "formType": 'Гістологія',
        "idetifier":[
            "color",
            "description",
            "conclusion",
            "doc",
            "archive",
            "sign"
        ],
        "title": 'Гістологія висновок',
        "dataType": 'doctor',
        "fields": [
            {
                "legend": 'Методи забарвлення',
                "id":1,
                "type": 'textarea',
                "required": true,
                "name": 'color',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Мікроопис',
                "id":2,
                "type": 'textarea',
                "required": true,
                "name": 'description',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Патоморфологічний висновок',
                "id":3,
                "type": 'textarea',
                "required": true,
                "name": 'conclusion',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Лікар',
                "id":4,
                "type": 'text',
                "required": true,
                "name": 'doc',
                "options": true,
                "props": []
            },
            {
                "legend": 'Категорія складності',
                "id":6,
                "type": 'radio',
                "required": false,
                "name": 'level',
                "options": false,
                "props": [
                    {
                    "label": '1',
                    "id":651,
                    "type": 'radio'
                    },
                    {
                    "label": '2',
                    "id":652,
                    "type": 'radio'
                    },
                    {
                    "label": '3',
                    "id":653,
                    "type": 'radio'
                    },
                    {
                    "label": '4',
                    "id":654,
                    "type": 'radio'
                    },
                    {
                    "label": '5',
                    "id":655,
                    "type": 'radio'
                    },
                ] 
            },
            {
                "legend": 'Зберігання в архіві',
                "id":5,
                "type": 'radio',
                "required": true,
                "name": 'archive',
                "options": false,
                "props": [
                    {
                    "label": '1 рік',
                    "id":661,
                    "type": 'radio'
                    },
                    {
                    "label": '3 Роки',
                    "id":662,
                    "type": 'radio'
                    },
                    {
                    "label": '10 Років',
                    "id":662,
                    "type": 'radio'
                    },
                ] 
            },
        ],
        "button": "Сформувати заключення",
        "class": 'form__box__register'
    }

]

const DocFormSlice = createSlice({
    name:'DocForm',
    initialState: values,
    reducers: {
        FormCreation: (state, action) => {
            state.push(action.payload);
        },
    }
})

export const {FormCreation} = DocFormSlice.actions;
export default DocFormSlice;